import { Routes } from "@angular/router";
import { loadTranslationResolver } from "@app/kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { DataProcessingApiService } from "./domains/data-processing/services/data-processing-api.service";
import { LicenseCategoryApiService } from "../../shared/crm/license-categories/services/license-category-api.service";
import { BlacklistRuleApiService } from "./domains/blacklist-rules/services/blacklist-rule-api.service";
import { CustomerDuplicationRuleApiService } from "./shared/customer-duplication-rules/services/customer-duplication-rule-api.service";
import { CompanyApiService } from "./domains/company/services/company-api.service";
import { CustomerApiService } from "./domains/customers/services/customer-api.service";
import { CompanyDuplicationRuleApiService } from "./shared/company-duplication-rules";

export const crmRoutes: Routes = [
  {
    path: "data-processing",
    loadChildren: () => import("./domains/data-processing/data-processing.routes").then(r => r.dataProcessingRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.DATA_PROCESSING.VIEW },
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.CRM.DATA_PROCESSING]) },
    providers: [DataProcessingApiService],
  },
  {
    path: "license-categories",
    loadChildren: () => import("./domains/license-categories/license-categories.routes").then(r => r.licenseCategoriesRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.LICENSE_CATEGORY.VIEW },
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.CRM.LICENSE_CATEGORIES]) },
    providers: [LicenseCategoryApiService],
  },
  {
    path: "crm-settings",
    loadChildren: () => import("./domains/crm-settings/crm-settings.routes").then(r => r.crmSettingsRoutes),
    canActivate: [AuthGuard],
    data: {
      authGuardOptions: [
        [COMMON_GUARD_OPTIONS.CRM_DUPLICATION_SETTINGS.VIEW],
        [COMMON_GUARD_OPTIONS.CUSTOMER_DUPLICATION_RULE.VIEW],
        [COMMON_GUARD_OPTIONS.COMPANY_DUPLICATION_RULE.VIEW],
        [COMMON_GUARD_OPTIONS.CRM_OTP_SETTINGS.VIEW],
        [COMMON_GUARD_OPTIONS.CRM_OPEN_API_SETTINGS.VIEW],
        [COMMON_GUARD_OPTIONS.CRM_EMAIL_VALIDITY_SETTINGS.VIEW],
        [COMMON_GUARD_OPTIONS.CRM_DOCUMENTS_SETTINGS.VIEW],
        [COMMON_GUARD_OPTIONS.CRM_DATA_CONVALIDATION_SETTINGS.VIEW],
      ],
    },
    providers: [CustomerDuplicationRuleApiService, CompanyDuplicationRuleApiService],
  },
  {
    path: "blacklist-rules",
    loadChildren: () => import("./domains/blacklist-rules/blacklist-rules.routes").then(r => r.blacklistRulesRoutes),
    canActivate: [AuthGuard],
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.CRM.BLACKLIST_RULES, TRANSLATION_PATHS.CRM.SHARED]) },
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.BLACKLIST_RULE.VIEW },
    providers: [BlacklistRuleApiService],
  },
  {
    path: "companies",
    loadChildren: () => import("./domains/company/company.routes").then(r => r.companiesRoutes),
    canActivate: [AuthGuard],
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.CRM.COMPANIES, TRANSLATION_PATHS.CRM.SHARED, TRANSLATION_PATHS.GEO_DATA.API_ERRORS]),
    },
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.COMPANY.VIEW },
    providers: [CompanyApiService],
  },
  {
    path: "customers",
    loadChildren: () => import("./domains/customers/customers.routes").then(r => r.customersRoutes),
    canActivate: [AuthGuard],
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.CRM.CUSTOMERS,
        TRANSLATION_PATHS.CRM.SHARED,
        TRANSLATION_PATHS.SCANNED_DOCUMENTS,
        TRANSLATION_PATHS.GEO_DATA.API_ERRORS,
      ]),
    },
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.CUSTOMER.VIEW },
    providers: [CustomerApiService],
  },
  {
    path: "duplications",
    loadChildren: () => import("./domains/duplication-clusters/duplication-clusters.routes").then(r => r.duplicationClustersRoutes),
    canActivate: [AuthGuard],
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.CRM.DUPLICATION_CLUSTERS,
        TRANSLATION_PATHS.CRM.SHARED,
        TRANSLATION_PATHS.CRM.COMPANIES,
        TRANSLATION_PATHS.CRM.CUSTOMERS,
        TRANSLATION_PATHS.GEO_DATA.API_ERRORS,
      ]),
    },
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.CRM_DUPLICATION_CLUSTERS.VIEW },
  },
];
